/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';
import { isEmpty } from '@ember/utils';
// External imports
import { hash } from '@linc-technologies/linced-common/utils/promise';

export default class IndexRoute extends Route {
  // The key is the controller's query param property name. The controller
  // aliases it to `jurisdictionsFilter` in the URL.
  queryParams = {
    jurisdictions: {
      refreshModel: true,
    },
  };

  // Services
  @service
  store;

  model(params) {
    const query = {};
    // The API takes the filter as a comma-separated list. Passing the array
    // straight through would make ember-data serialise it as
    // `jurisdictions[]=1&jurisdictions[]=4`, which the API does not read, so
    // it silently returned every usage set. Omit the param entirely when
    // nothing is selected.
    if (!isEmpty(params.jurisdictions)) {
      query.jurisdictions = params.jurisdictions.join(',');
    }
    return hash({
      usageSets: this.store.query('schools/usage-set', query),
    });
  }
}
